function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import lazyGettext from 'js-utils/lazy-gettext';
import Link from 'eventbrite_design_system/link/Link';
import Icon from 'eventbrite_design_system/icon/Icon';
import HelpChunkySVG from 'eventbrite_design_system/iconography/icons/HelpChunky';
var DEFAULT_TEXT_CONTENT = lazyGettext('Learn more about');

var Guidance =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Guidance, _PureComponent);

  function Guidance() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Guidance);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Guidance)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "_handleDangerouslySetLinkAction", function (e) {
      // Event handler is not fired on any element used as string inside dangerouslySetInnerHTML
      // We instead leverage event delegation to properly handle the link interactions
      if (e.target.className === 'eds-guidance__content-link' || e.keycode === 13) {
        _this._handleLinkClick();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleLinkClick", function () {
      var linkConfig = _this.props.linkConfig;

      if (linkConfig.onLinkClick) {
        linkConfig.onLinkClick();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_renderPrimaryIcon", function () {
      var primaryIcon = _this.props.primaryIcon;
      var __containerClassName = 'eds-guidance__icon';
      var component = null;

      if (primaryIcon) {
        // Apply additional props to inner <i> element of Icon
        component = React.cloneElement(_this.props.primaryIcon, // Apply additional classes to inner <i> element of Icon
        {
          __containerClassName: __containerClassName,
          size: 'small'
        });
      }

      return component;
    });

    _defineProperty(_assertThisInitialized(_this), "_getLinkIcon", function () {
      var linkConfig = _this.props.linkConfig;
      var component = null;

      if (linkConfig && linkConfig.linkIcon) {
        // Apply additional props to Icon
        var icon = React.cloneElement(linkConfig.linkIcon, {
          size: 'xsmall',
          color: 'ui-blue'
        });
        component = React.createElement(Link, {
          to: linkConfig.linkTo,
          onClick: _this._handleLinkClick,
          target: "_blank"
        }, icon, React.createElement("span", {
          className: "eds-is-hidden-accessible"
        }, linkConfig.linkText));
      }

      return component;
    });

    _defineProperty(_assertThisInitialized(_this), "_renderContent", function () {
      var _this$props = _this.props,
          linkConfig = _this$props.linkConfig,
          textContent = _this$props.textContent;
      var linkText = linkConfig.linkText,
          linkTo = linkConfig.linkTo;
      var translatedContent = {
        __html: lazyGettext( // eslint-disable-next-line gettext/no-variable-string
        "\n                    <span\n                        className=\"eds-guidance__content-copy\"\n                        data-spec=\"eds-guidance__content-copy\"\n                    >\n                        %(textContent)s\n                    </span>\n                    <a\n                        href=%(linkTo)s\n                        target=\"_blank\"\n                        class=\"eds-guidance__content-link\"\n                    >\n                        %(linkText)s\n                    </a>\n                ", {
          textContent: textContent,
          linkTo: linkTo,
          linkText: linkText
        })
      };
      return (// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        React.createElement("div", {
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML: translatedContent,
          "data-spec": "eds-guidance__content--translated",
          onClick: _this._handleDangerouslySetLinkAction,
          onKeyDown: _this._handleDangerouslySetLinkAction,
          role: "contentinfo"
        })
      );
    });

    return _this;
  }

  _createClass(Guidance, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "eds-guidance"
      }, this._renderPrimaryIcon(), React.createElement("div", {
        className: "eds-guidance__content",
        "data-spec": "eds-guidance__content"
      }, this._renderContent(), this._getLinkIcon()));
    }
  }]);

  return Guidance;
}(PureComponent);

_defineProperty(Guidance, "propTypes", {
  /**
   * Primary copy to display in component
  */
  textContent: EBPropTypes.translation,

  /**
   * Left aligned icon
  */
  primaryIcon: PropTypes.node,

  /**
   * Configuration for the link. {linkText:TranslatedString, linkTo:String, onLinkClick:Function, linkIcon:Icon}
  */
  linkConfig: PropTypes.shape({
    /**
     * Text content for link
    */
    linkText: EBPropTypes.translation.isRequired,

    /**
     * Text content for link
    */
    linkTo: PropTypes.string.isRequired,

    /**
     * Click handler for link
    */
    onLinkClick: PropTypes.func,

    /**
     * Icon to display right aligned in the pill
    */
    linkIcon: PropTypes.node
  }).isRequired
});

_defineProperty(Guidance, "defaultProps", {
  primaryIcon: React.createElement(Icon, {
    type: React.createElement(HelpChunkySVG, null)
  }),
  textContent: DEFAULT_TEXT_CONTENT
});

export { Guidance as default };